import { data } from './mockData';
import './styles.scss';

const RealProductSidebar = ({ title }) => (
    <div className="real-product-sidebar">
        <div className="description-demibold real-product-sidebar__title">{title}</div>
        <div className="product-sidebar-cards">
            {data.map((item, index) => (
                <a href="/#" key={index} className="product-sidebar-card">
                    <img src={item.img} alt="" />
                </a>
            ))}
        </div>
    </div>
);

export default RealProductSidebar;
